export const LEARNING_CATEGORIES = [
  {
    id: 'astronomy-astrophysics',
    title: 'Astronomy & Astrophysics',
    description: 'Celestial bodies, phenomena, and the physics of the universe.',
    icon: '🌌'
  },
  {
    id: 'space-exploration',
    title: 'Space Exploration',
    description: 'Missions, spacecraft, and human activities in space.',
    icon: '🚀'
  },
  {
    id: 'rocketry-spacecraft',
    title: 'Rocketry & Spacecraft Technology',
    description: 'Rocket design, propulsion, and spacecraft systems.',
    icon: '🛰️'
  },
  {
    id: 'satellites-infrastructure',
    title: 'Satellites & Space Infrastructure',
    description: 'Satellite functions, orbits, and space-based networks.',
    icon: '📡'
  },
  {
    id: 'planetary-science',
    title: 'Planetary Science',
    description: 'Planets, moons, and other bodies in our solar system.',
    icon: '🪐'
  },
  {
    id: 'space-history-culture',
    title: 'Space History & Culture',
    description: 'Historical milestones, figures, and cultural impacts of space.',
    icon: '📚'
  }
];
